import { Request } from '../../Servidor/Request';

export class PropertyTypeRequest {
    private sgeptipoimovel: number;
    private nome: string;
    private codigo: string

    constructor(sgeptipoimovel: number, nome: string, codigo: string) {
        this.sgeptipoimovel = sgeptipoimovel;
        this.nome = nome;
        this.codigo = codigo;
    }


    /**
     * Getter sgeptipoimovel
     * @return {number}
     */
    public getSgepTipoImovel(): number {
        return this.sgeptipoimovel;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
     /**
     * Getter codigo
     * @return {string}
     */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class PropertyTypeStructRequest {
    private sgeptipoimovel: number;

    constructor(sgeptipoimovel: number) {
        this.sgeptipoimovel = sgeptipoimovel;
    }


    /**
     * Getter sgeptipoimovel
     * @return {number}
     */
    public getSgepTipoImovel(): number {
        return this.sgeptipoimovel;
    }

}

export class PropertyTypeStructResponse {
    private sgeptipoimovel: number;
    private nome: string;

    constructor(sgeptipoimovel: number, nome: string) {
        this.sgeptipoimovel = sgeptipoimovel;
        this.nome = nome;
    }


    /**
     * Getter sgeptipoimovel
     * @return {number}
     */
    public getSgepTipoImovel(): number {
        return this.sgeptipoimovel;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class PropertyTypeInteractor {
    public fetchSave(request: PropertyTypeRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/tipo-imovel/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: PropertyTypeStructRequest): PromiseLike<PropertyTypeStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/tipo-imovel/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}